import type { ReactNode } from "react";
import SpeechHeading from "@/components/ui/SpeechHeading";

type PageHeadingProps = {
  title: string;
  subtitle?: ReactNode;
  eyebrow?: string;
  actions?: ReactNode;
};

// Kept as a thin alias over SpeechHeading so the ~20 pages already calling
// PageHeading pick up the Boba Bash treatment without touching each one.
export default function PageHeading(props: PageHeadingProps) {
  return <SpeechHeading {...props} />;
}
